// TODO: get rid of ErrorBoundary component usage.
import React from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getDatasourceErrorMessage,
  getIsDatasourceReady,
  getIsGuest,
  getIsSelfHosted,
} from '@/store-selectors';
import { CreditLimitWarning } from '@/features/credits/components/CreditLimitWarning';
import { WidgetConfigurationSidebar } from '@/features/dashboard/components/WidgetConfigurationSidebar';
import sidebarMenu from '@/css/module/sidebarMenu.css';
import AjaxSpinner from '@/components/AjaxSpinner';
import { MainSideBar } from '@/components/MainSideBar';
import ErrorBoundary from '@/components/ErrorBoundary';
import { DASHBOARD_URL_PATH } from '@/routing/paths';
import { useDatasourceId } from '@/hooks';
import { SharePublishEmbedSidebar } from '@/features/dashboard/components/SharePublishEmbedSidebar';
import Modal from '../Modal';
import AlertMessageHolder from '../AlertMessageHolder';
import FlashMessageHolder from '../FlashMessageHolder';
import {
  ContentContainer,
  Placeholder,
} from './PrivateDatasourceAppPage.styles';

const LoadingSpinner = () => (
  <Placeholder>
    <AjaxSpinner />
  </Placeholder>
);
export const PrivateDatasourceAppPage: React.FC = () => {
  const navigate = useNavigate();
  const datasourceId = useDatasourceId();
  // TODO: organize CSS and markup properly to avoid using this flag.
  const isDashboardView = !!useMatch(DASHBOARD_URL_PATH);
  const isDatasourceReady = useSelector(getIsDatasourceReady);
  const isSelfHosted = useSelector(getIsSelfHosted);
  const isGuest = useSelector(getIsGuest);
  const datasourceErrorMessage = useSelector(getDatasourceErrorMessage);

  React.useEffect(() => {
    if (isGuest && !isDashboardView) {
      navigate(`/datasources/${datasourceId}/dashboards`);
    }
  }, [isGuest, isDashboardView]);

  return (
    <div>
      <FlashMessageHolder />
      <AlertMessageHolder />
      <Modal />
      {!isSelfHosted && <CreditLimitWarning />}

      <div>
        <div className={sidebarMenu.pageContainer}>
          <ErrorBoundary>
            <MainSideBar />
          </ErrorBoundary>

          <ContentContainer isDashboardView={isDashboardView}>
            {isDatasourceReady && (
              <React.Suspense fallback={<LoadingSpinner />}>
                <ErrorBoundary>
                  <Outlet />
                </ErrorBoundary>
              </React.Suspense>
            )}
            {!isDatasourceReady && !datasourceErrorMessage && (
              <LoadingSpinner />
            )}

            {!isDatasourceReady && datasourceErrorMessage && (
              <div className="alert alert-danger">
                Problem loading tables: {datasourceErrorMessage}
              </div>
            )}
            <WidgetConfigurationSidebar />
            <SharePublishEmbedSidebar />
          </ContentContainer>
        </div>
      </div>
    </div>
  );
};
